var render = function render(){var _vm=this,_c=_vm._self._c;return _c('billing-report-panel',{attrs:{"report-key":"invoices-batch","route":"/reports/billing-invoices-batch","file-name":"notas-fiscais-por-lote.xlsx","period-label":"Período de fechamento do lote","columns":_vm.columns,"default-days":180}})
}
var staticRenderFns = []

export { render, staticRenderFns }